import React, { useState, useEffect } from "react";
import { Search, MoreVertical, ChevronDown } from "lucide-react";
import Suppliers from "./Suppliers";
import SavedSuppliers from "./SavedSuppliers";
import "../Dashboard.css";
import Tabs from "../../UILibrary/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { setTabs } from "../../../store/tabSlice";
import MetricPage from "./Metric/MetricPage";
import { getFolderCountsByBuyerId } from "../../../store/suppliersManagementSlice";

const postSuppliers = [
  {
    id: 1,
    name: "Larry Hillsworth",
    company: "Qualcomm",
    date: "Mar 16, 2025, 10:00 PM",
    status: "No Action",
  },
  {
    id: 2,
    name: "Larry Hillsworth",
    company: "Qualcomm",
    date: "Mar 16, 2025, 10:00 PM",
    status: "No Action",
  },
  {
    id: 3,
    name: "Larry Hillsworth",
    company: "Qualcomm",
    date: "Mar 16, 2025, 10:00 PM",
    status: "No Action",
  },
];
const Management = () => {
  const [selectedTab, setSelectedTab] = useState("Suppliers");
  const tabs = ["Suppliers", "Saved Suppliers", "Metric", "Registration"];
  const [isSavedSuppliers, setSavedSuppliers] = useState(false);
  const [isNewSupplierClicked, setNewSupplierClicked] = useState(false);
  const userId = useSelector((state) => state.auth.id);
  const dispatch = useDispatch();
  const [suppliers, setSuppliers] = React.useState(postSuppliers);
  useEffect(() => {
    dispatch(setTabs(tabs));
    // dispatch(getFolderCountsByBuyerId(userId));
  }, []);

  const handleStatusChange = (id, newStatus) => {
    setSuppliers((prev) =>
      prev.map((supplier) =>
        supplier.id === id ? { ...supplier, status: newStatus } : supplier
      )
    );
  };

  const handleTabClick = (tab) => {
    if (tab === "Saved Suppliers") {
      setSavedSuppliers(true);
    }
    setSelectedTab(tab);
  };

  const handleCreateSupplier = () => {
    setNewSupplierClicked(true);
  };

  return (
    <div>
      <div style={{ position: "relative" }}>
        <div className="flex justify-between items-center mb-6 mt-6 pl-3">
          <Tabs
            title="Supplier Management"
            tabs={tabs}
            onTabChange={handleTabClick}
          />
          {selectedTab === "Suppliers" && (
            <div className="flex items-center">
              <button
                type="submit"
                onClick={handleCreateSupplier}
                className="inline-flex h-[47px] px-4 py-[6px] justify-start items-center opacity-90 bg-[#EAF524] rounded-lg text-black font-semibold border-0 mr-5"
              >
                <svg
                  className="mr-2"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 6V18M18 12H6"
                    stroke="#1D2739"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                Create Suppliers
              </button>
            </div>
          )}
        </div>

        {selectedTab === "Saved Suppliers" ? (
          <SavedSuppliers isSavedSuppliers={isSavedSuppliers}/>
        ) : selectedTab === "Metric" ? (
          <MetricPage />
        ) : selectedTab === "Registration" ? (
          <>
            <div className="flex items-center justify-between p-6">
              <div className="flex items-center gap-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search"
                    className="w-[400px] pl-10 pr-4 py-2 bg-gray-100 rounded-lg text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
                </div>
                <button className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors font-medium">
                  Search
                </button>
              </div>

              <div className="flex items-center gap-4">
                <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                  <span className="text-gray-700">All</span>
                  <ChevronDown className="w-4 h-4 text-gray-500" />
                </button>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 19H7C7.28333 19 7.52083 19.0958 7.7125 19.2875C7.90417 19.4792 8 19.7167 8 20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H4C3.71667 21 3.47917 20.9042 3.2875 20.7125C3.09583 20.5208 3 20.2833 3 20V17C3 16.7167 3.09583 16.4792 3.2875 16.2875C3.47917 16.0958 3.71667 16 4 16C4.28333 16 4.52083 16.0958 4.7125 16.2875C4.90417 16.4792 5 16.7167 5 17V19ZM19 19V17C19 16.7167 19.0958 16.4792 19.2875 16.2875C19.4792 16.0958 19.7167 16 20 16C20.2833 16 20.5208 16.0958 20.7125 16.2875C20.9042 16.4792 21 16.7167 21 17V20C21 20.2833 20.9042 20.5208 20.7125 20.7125C20.5208 20.9042 20.2833 21 20 21H17C16.7167 21 16.4792 20.9042 16.2875 20.7125C16.0958 20.5208 16 20.2833 16 20C16 19.7167 16.0958 19.4792 16.2875 19.2875C16.4792 19.0958 16.7167 19 17 19H19ZM5 5V7C5 7.28333 4.90417 7.52083 4.7125 7.7125C4.52083 7.90417 4.28333 8 4 8C3.71667 8 3.47917 7.90417 3.2875 7.7125C3.09583 7.52083 3 7.28333 3 7V4C3 3.71667 3.09583 3.47917 3.2875 3.2875C3.47917 3.09583 3.71667 3 4 3H7C7.28333 3 7.52083 3.09583 7.7125 3.2875C7.90417 3.47917 8 3.71667 8 4C8 4.28333 7.90417 4.52083 7.7125 4.7125C7.52083 4.90417 7.28333 5 7 5H5ZM19 5H17C16.7167 5 16.4792 4.90417 16.2875 4.7125C16.0958 4.52083 16 4.28333 16 4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3H20C20.2833 3 20.5208 3.09583 20.7125 3.2875C20.9042 3.47917 21 3.71667 21 4V7C21 7.28333 20.9042 7.52083 20.7125 7.7125C20.5208 7.90417 20.2833 8 20 8C19.7167 8 19.4792 7.90417 19.2875 7.7125C19.0958 7.52083 19 7.28333 19 7V5Z"
                    fill="#1D2739"
                  />
                </svg>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow overflow-hidden">
              {/* Table Header */}
              <div className="bg-[#F7F7F7] px-6 py-3 border-b">
                <div className="grid grid-cols-[0.5fr_2fr_2fr_2.5fr_3.5fr_0.5fr] text-base text-[#1D2739] items-center">
                  <div></div>
                  <div className="text-left text-sm">Supplier Name</div>
                  <div className="text-left text-sm">Company</div>
                  <div className="text-left text-sm">Date Submitted</div>
                  <div className="text-left whitespace-nowrap text-sm">
                    Document Verification Status
                  </div>
                  <div className="text-left text-sm"></div>
                </div>
              </div>

              {/* Table Rows */}
              {suppliers.map((supplier) => (
                <div
                  key={supplier.id}
                  className="px-6 py-4 border-b border-gray-200 hover:bg-gray-50"
                >
                  <div className="grid grid-cols-[0.5fr_2fr_2fr_2.5fr_3.5fr_0.5fr] items-center gap-4">
                    {/* Supplier Name with checkmark */}
                    <div className="flex items-center text-gray-900 text-sm">
                      {/* <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-black text-white"> */}
                      {supplier.status !== "No Action" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5ZM10.692 14.0715L8.3595 11.7375C8.27588 11.6539 8.17661 11.5876 8.06736 11.5423C7.9581 11.497 7.84101 11.4737 7.72275 11.4737C7.60449 11.4737 7.4874 11.497 7.37814 11.5423C7.26889 11.5876 7.16962 11.6539 7.086 11.7375C6.91712 11.9064 6.82225 12.1354 6.82225 12.3743C6.82225 12.6131 6.91712 12.8421 7.086 13.011L10.056 15.981C10.1394 16.065 10.2386 16.1317 10.3479 16.1773C10.4571 16.2228 10.5744 16.2462 10.6927 16.2462C10.8111 16.2462 10.9284 16.2228 11.0376 16.1773C11.1469 16.1317 11.2461 16.065 11.3295 15.981L17.4795 9.8295C17.5642 9.74623 17.6316 9.647 17.6778 9.53755C17.724 9.42809 17.7481 9.31057 17.7487 9.19177C17.7492 9.07297 17.7262 8.95523 17.6811 8.84535C17.6359 8.73547 17.5694 8.63562 17.4854 8.55156C17.4015 8.46751 17.3017 8.4009 17.1919 8.3556C17.0821 8.31029 16.9644 8.28718 16.8455 8.28759C16.7267 8.288 16.6092 8.31193 16.4997 8.358C16.3902 8.40407 16.2909 8.47136 16.2075 8.556L10.692 14.0715Z"
                            fill="black"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="flex items-center gap-2 text-gray-900 text-sm">
                      {supplier.name}
                    </div>

                    <div className="text-left text-gray-900 text-sm">
                      {supplier.company}
                    </div>

                    <div className="text-left text-gray-600 text-sm">
                      {supplier.date}
                    </div>

                    <div className="text-left flex justify-between items-center">
                      <div className="flex">
                        {supplier.status === "Verified" && (
                          <span className="px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-600">
                            Verified
                          </span>
                        )}
                        {supplier.status === "Rejected" && (
                          <span className="px-3 py-1 text-xs font-medium rounded-full bg-red-100 text-red-600">
                            Rejected
                          </span>
                        )}
                        {supplier.status === "No Action" && (
                          <span className="px-3 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-600">
                            No Action
                          </span>
                        )}
                      </div>

                      <div className="flex">
                        <button className="p-1 hover:bg-gray-100 rounded">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M4 20C3.71667 20 3.47917 19.9042 3.2875 19.7125C3.09583 19.5208 3 19.2833 3 19C3 18.7167 3.09583 18.4792 3.2875 18.2875C3.47917 18.0958 3.71667 18 4 18H14C14.2833 18 14.5208 18.0958 14.7125 18.2875C14.9042 18.4792 15 18.7167 15 19C15 19.2833 14.9042 19.5208 14.7125 19.7125C14.5208 19.9042 14.2833 20 14 20H4ZM16 13C14.6167 13 13.4375 12.5125 12.4625 11.5375C11.4875 10.5625 11 9.38333 11 8C11 6.61667 11.4875 5.4375 12.4625 4.4625C13.4375 3.4875 14.6167 3 16 3C17.3833 3 18.5625 3.4875 19.5375 4.4625C20.5125 5.4375 21 6.61667 21 8C21 9.38333 20.5125 10.5625 19.5375 11.5375C18.5625 12.5125 17.3833 13 16 13ZM4 12C3.71667 12 3.47917 11.9042 3.2875 11.7125C3.09583 11.5208 3 11.2833 3 11C3 10.7167 3.09583 10.4792 3.2875 10.2875C3.47917 10.0958 3.71667 10 4 10H8.675C8.95833 10 9.19583 10.0958 9.3875 10.2875C9.57917 10.4792 9.675 10.7167 9.675 11C9.675 11.2667 9.57917 11.5 9.3875 11.7C9.19583 11.9 8.95833 12 8.675 12H4ZM4 16C3.71667 16 3.47917 15.9042 3.2875 15.7125C3.09583 15.5208 3 15.2833 3 15C3 14.7167 3.09583 14.4792 3.2875 14.2875C3.47917 14.0958 3.71667 14 4 14H11.925C12.2083 14 12.4458 14.0958 12.6375 14.2875C12.8292 14.4792 12.925 14.7167 12.925 15C12.925 15.2667 12.8333 15.5 12.65 15.7C12.4667 15.9 12.225 16 11.925 16H4ZM16 11C16.1333 11 16.25 10.95 16.35 10.85C16.45 10.75 16.5 10.6333 16.5 10.5V7.5C16.5 7.36667 16.45 7.25 16.35 7.15C16.25 7.05 16.1333 7 16 7C15.8667 7 15.75 7.05 15.65 7.15C15.55 7.25 15.5 7.36667 15.5 7.5V10.5C15.5 10.6333 15.55 10.75 15.65 10.85C15.75 10.95 15.8667 11 16 11ZM16 6C16.1333 6 16.25 5.95 16.35 5.85C16.45 5.75 16.5 5.63333 16.5 5.5C16.5 5.36667 16.45 5.25 16.35 5.15C16.25 5.05 16.1333 5 16 5C15.8667 5 15.75 5.05 15.65 5.15C15.55 5.25 15.5 5.36667 15.5 5.5C15.5 5.63333 15.55 5.75 15.65 5.85C15.75 5.95 15.8667 6 16 6Z"
                              fill="#0088FF"
                            />
                          </svg>
                        </button>
                        {/* Approve */}
                        <button
                          className="p-1 hover:bg-gray-100 rounded text-green-600"
                          onClick={() =>
                            handleStatusChange(supplier.id, "Verified")
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M10.6 13.8L8.45 11.65C8.26667 11.4667 8.03333 11.375 7.75 11.375C7.46667 11.375 7.23333 11.4667 7.05 11.65C6.86667 11.8333 6.775 12.0667 6.775 12.35C6.775 12.6333 6.86667 12.8667 7.05 13.05L9.9 15.9C10.1 16.1 10.3333 16.2 10.6 16.2C10.8667 16.2 11.1 16.1 11.3 15.9L16.95 10.25C17.1333 10.0667 17.225 9.83333 17.225 9.55C17.225 9.26667 17.1333 9.03333 16.95 8.85C16.7667 8.66667 16.5333 8.575 16.25 8.575C15.9667 8.575 15.7333 8.66667 15.55 8.85L10.6 13.8ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                              fill="#02AD28"
                            />
                          </svg>
                        </button>
                        {/* Reject */}
                        <button
                          className="p-1 hover:bg-gray-100 rounded text-red-600"
                          onClick={() =>
                            handleStatusChange(supplier.id, "Rejected")
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M12 13.4L14.9 16.3C15.0833 16.4833 15.3167 16.575 15.6 16.575C15.8833 16.575 16.1167 16.4833 16.3 16.3C16.4833 16.1167 16.575 15.8833 16.575 15.6C16.575 15.3167 16.4833 15.0833 16.3 14.9L13.4 12L16.3 9.1C16.4833 8.91667 16.575 8.68333 16.575 8.4C16.575 8.11667 16.4833 7.88333 16.3 7.7C16.1167 7.51667 15.8833 7.425 15.6 7.425C15.3167 7.425 15.0833 7.51667 14.9 7.7L12 10.6L9.1 7.7C8.91667 7.51667 8.68333 7.425 8.4 7.425C8.11667 7.425 7.88333 7.51667 7.7 7.7C7.51667 7.88333 7.425 8.11667 7.425 8.4C7.425 8.68333 7.51667 8.91667 7.7 9.1L10.6 12L7.7 14.9C7.51667 15.0833 7.425 15.3167 7.425 15.6C7.425 15.8833 7.51667 16.1167 7.7 16.3C7.88333 16.4833 8.11667 16.575 8.4 16.575C8.68333 16.575 8.91667 16.4833 9.1 16.3L12 13.4ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                              fill="#B53E3E"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div className="text-left flex justify-end">
                      <button className="p-1 hover:bg-gray-100 rounded transition-colors">
                        <MoreVertical className="w-5 h-5 text-gray-600" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <Suppliers
            isNewSupplierClicked={isNewSupplierClicked}
            setNewSupplierClicked={setNewSupplierClicked}
            title="Management"
            tabs={tabs}
            onTabChange={handleTabClick}
            selectedTab={selectedTab}
          />
        )}
      </div>
    </div>
  );
};
export default Management;
